// ============================================
// RESET PASSWORD PAGE — public route
// /reset-password/:token
// ============================================

import React, { useState } from "react";
import { useTheme } from "../components/ThemeContext";
import { apiResetPassword } from "../services/api";

export default function ResetPassword({ token }) {
  const { C } = useTheme();
  const [pw, setPw]     = useState("");
  const [pw2, setPw2]   = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (pw.length < 8) return setError("Password must be at least 8 characters");
    if (pw !== pw2)    return setError("Passwords don't match");

    setBusy(true);
    try {
      await apiResetPassword(token, pw);
      setDone(true);
    } catch(err) {
      setError(err.response?.data?.message || "Reset failed");
      setBusy(false);
    }
  };

  const inp = { width:"100%", padding:"11px 14px", background:C.inputBg, border:`1px solid ${C.border}`, borderRadius:9, color:C.text, fontSize:14, outline:"none", boxSizing:"border-box" };

  if (done) {
    return (
      <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:"24px 16px", background:C.bg }}>
        <div style={{ width:"100%", maxWidth:420, textAlign:"center" }}>
          <div style={{ fontSize:48, marginBottom:14 }}>✅</div>
          <div style={{ fontSize:20, fontWeight:800, color:C.text, marginBottom:8 }}>Password reset</div>
          <div style={{ fontSize:13, color:C.muted, marginBottom:24 }}>You can now sign in with your new password.</div>
          <a href="/" style={{ display:"inline-block", padding:"11px 26px", background:C.accent, borderRadius:9, color:"#000", fontSize:13, fontWeight:700, textDecoration:"none" }}>
            Go to Sign In
          </a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:"24px 16px", background:C.bg }}>
      <div style={{ width:"100%", maxWidth:420 }}>
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <div style={{ fontSize:28, fontWeight:800, color:C.text, fontFamily:"Georgia, serif", marginBottom:6 }}>New password</div>
          <div style={{ fontSize:13, color:C.muted }}>Choose a strong password for your account</div>
        </div>

        <form onSubmit={submit} style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:14, padding:"28px 26px" }}>
          {error && (
            <div style={{ padding:"10px 14px", borderRadius:8, marginBottom:14, background:C.redSoft, border:`1px solid ${C.red}44`, color:C.red, fontSize:13, fontWeight:600 }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom:14 }}>
            <div style={{ fontSize:11, fontWeight:600, color:C.muted, marginBottom:6, textTransform:"uppercase", letterSpacing:"0.5px" }}>New password</div>
            <input type="password" autoFocus value={pw} onChange={e=>setPw(e.target.value)} placeholder="At least 8 characters" style={inp} required />
          </div>

          <div style={{ marginBottom:18 }}>
            <div style={{ fontSize:11, fontWeight:600, color:C.muted, marginBottom:6, textTransform:"uppercase", letterSpacing:"0.5px" }}>Confirm password</div>
            <input type="password" value={pw2} onChange={e=>setPw2(e.target.value)} placeholder="Re-enter password" style={inp} required />
          </div>

          <button type="submit" disabled={busy}
            style={{ width:"100%", padding:"12px", background:busy?C.border:C.accent, border:"none", borderRadius:9, color:busy?C.muted:"#000", fontSize:14, fontWeight:700, cursor:busy?"not-allowed":"pointer" }}>
            {busy ? "Resetting…" : "Reset password"}
          </button>
        </form>
      </div>
    </div>
  );
}